import { useTranslate } from '../../../../../hooks/useTranslate';
import { FeatureId } from '../../../types';
import { NavMark } from '../types';

export function useNavMarks(): NavMark[] {
  const { staticTranslate } = useTranslate();

  return [
    {
      featureId: FeatureId.map,
      name: staticTranslate('Map'),
    },
    {
      featureId: FeatureId.photo,
      name: staticTranslate('Photos'),
    },
    {
      featureId: FeatureId.feedbacks,
      name: staticTranslate('Reviews'),
    },
  ];
}
